import { doRequest, HttpMethodEnum } from '../lib/httpHelper';
import { SignupUser } from '../models/user.interface';
import { Service } from './service';

export default class UserService extends Service {
  async login(email: string, password: string) {
    return await doRequest({
      auth: false,
      method: HttpMethodEnum.POST,
      url: `${this.root}v1/auth/normal`,
      body: { email, password },
    });
  }

  /**
   * API call to send the verification code to the phone number in input
   * @param phone
   */
  async startVerification(phone) {
    return await doRequest({
      auth: false,
      url: `${this.root}v1/verify/start`,
      method: HttpMethodEnum.POST,
      body: { phone },
    });
  }

  /**
   * API call to check the verification code inserted by the user
   * @param phone
   * @param code
   */
  async checkVerification(phone, code) {
    return await doRequest({
      auth: false,
      url: `${this.root}v1/verify/check`,
      method: HttpMethodEnum.POST,
      body: { phone, code },
    });
  }

  /**
   * Api call to register a new user.
   *
   * @param {SignupUser} user
   */
  async signup(user: SignupUser) {
    return await doRequest({
      auth: false,
      method: HttpMethodEnum.POST,
      url: `${this.root}v1/signup/normal`,
      body: user,
    });
  }

  async getActiveGiftcard() {
    return await doRequest({
      auth: true,
      url: `${this.root}v1/discounts/giftcard/use`,
      method: HttpMethodEnum.GET,
    });
  }

  async changePassword(body: { oldPassword: string; newPassword: string }) {
    return await doRequest({
      auth: true,
      url: `${this.root}v2/users/change-password`,
      method: HttpMethodEnum.PATCH,
      body,
    });
  }

  async forgotPassword(email: string) {
    return await doRequest({
      auth: false,
      url: `${this.root}v1/users/resetpwd`,
      method: HttpMethodEnum.POST,
      body: { email },
    });
  }
}
